import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { Preference } from '../../../types/Preference';
import CustomAxios from '../../../utility/customAxios';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

export const updatePreference = async (uuid: string, formData: Preference) => {
  const response = await CustomAxios.put(`preferences/${uuid}`, formData);
  const { data } = response;
  return data;
};
interface UseUpdatePreferenceFormProps {
  uuid: string;
  onSuccessCallback: () => void;
}
export function useUpdatePreference({ uuid, onSuccessCallback }: UseUpdatePreferenceFormProps) {
  return useMutation({
    mutationFn: (formData: Preference) => updatePreference(uuid, formData),
    onSuccess: () => {
      // call success
      onSuccessCallback();
    },
    onError: (err: AxiosError) => {
      if (err?.response?.status === 400) {
        const preference: Preference = err.response.data as Preference;
        queryClient.setQueryData([queryKeys.allPreferences, preference.uuid], preference);
      }
    },
  });
}
